<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main" style="padding: 10px;">
          <div class="title">
            关于我们
          </div>
          <div class="contentLeft">
            <ul class="leftNavigation">
              <li><a href="javascript:void(0);"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>分析测试</a></li>
              <li><a href="javascript:void(0);"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>&nbsp;&nbsp;公共仪器平台</a></li>
            </ul>
          </div>
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
    <!--
    <v-footer></v-footer>
    <v-copy></v-copy>
    -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
import $ from "jquery";
export default {
  data () {
    return {
      centerList: [],
      platformList: [],
      richText: '',
    };
  },
  mounted () {
    // 科研服务列表
    //为了在内部函数能使用外部函数的this对象，要给它赋值了一个名叫self的变量。
    var self = this;

    $.ajax({
      url:  Header.IP_URL + '/research_service/simpleList',
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      //把从json获取的数据赋值给数组
      self.allList = res.data;
      for(var i=0;i < self.allList.length; i++){
        if (self.allList[i].type == '1')
          self.centerList.add(self.allList[i]);
        else
          self.platformList.add(self.allList[i]);
      }
    }).fail(function () {
      console.log('失败');
    });


    this.richText = '<p style="text-align: left;"><span style="margin-left: 295px; font-size: 22px; border-bottom: solid 3px #0c5cc8;">研究院简介</span></p>'
      + '<br/>'
      + '<p style="margin-left: 295px; margin-bottom : 20px；"><span style="margin-left: 36px; font-size: 16px;">上海交通大学转化医学研究院是上海交通大学下设直属单位，主要承担转化医学国家重大科技基础设施（上海）运行与科研管理，承担建立设施能力合作共享网络，组织策划重大科学研究计划，建立大科学协作网络，开展新型国家科学中心的建设实践。</span></p>'
      + '<p style="margin-left: 295px; margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">上海交通大学转化医学研究院其宗旨是打破基础医学与临床医学之间的屏障，真正构建从实验室到病床，把基础研究成果快速转化为临床治疗的新研究体系。利用现有的临床医学和基础医学优势，综合学校其它学科的研究力量，力争在重大疾病的研究和诊治上取得重大突破。</span></p>'
      + '<div style="margin-top:50px; margin-bottom: 0px"><div style="margin-left: 295px; font-size: 20px;"><b style="color: #0c5cc8; "></b> 研究领域</span></p>'
      + '<p style="margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">&nbsp;研究院针对我国重大疾病诊疗中的重大关键技术，围绕癌症、心脑血管疾病、代谢性疾病等三大疾病，研究相关发病机理和规律，建立相关疾病预测、预防、早期诊断和个体化治疗的理论、模型和方法，解决重大疾病的发生、发展与转归中的重大科学问题。</span></p>'
      + '<div style="margin-left : 0px; margin-top:30px; margin-bottom: 0px"><div style="font-size: 20px;"><b style="color: #0c5cc8; "></b> 主要职能</span></p>'
      + '<p style="margin-bottom : 0px"><span style="margin-left: 36px; font-size: 16px;">（一）转化医学国家重大科技基础设施（上海）运行管理中心（暨运行管理委员会秘书处）。承担国家设施的运行管理职责，包括设施系统能力维持与提升、开放运行与共享服务管理；</span></p>'
      + '<p style="margin-bottom : 0px"><span style="margin-left: 36px; font-size: 16px;">（二）转化医学国家科学中心行政委员会。推进“大设施”合作网络与“大科学”协作网络建设，通过“两网融合”促进大健康科研事业发展；</span></p>'
      + '<p style="margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">（三）上海交通大学大健康领域“大科学”交叉研究示范区。探索创新科研组织、人才引进与聘任模式，培育新兴交叉特色学科。</span></p>'
      + '<div style="margin-left : 0px; margin-top:30px; margin-bottom: 0px"><div style="font-size: 20px;"><b style="color: #0c5cc8; "></b> 研究基地</span></p>'
      + '<p style="margin-bottom : 0px"><span style="margin-left: 36px; font-size: 16px;">&nbsp;两大基地，协同合作，加速前沿技术和基础医学研究成果向临床应用转化。</span></p>'
      + '<p style="margin-bottom : 0px"><span style="margin-left: 36px; font-size: 16px;">（一）闵行基地：大学部基地位于闵行校区内，其职能为面向诊断（试剂与材料）、药物、医疗装备、新诊疗技术（医学大数据等）等方面的研究开发工作；通过组织重大项目、服务重大项目（系统能力、用户开放）方式来推进基地开放运行；</span></p>'
      + '<p style="margin-bottom : 0px"><span style="margin-left: 36px; font-size: 16px;">（二）瑞金基地：位于附属瑞金医院内，其职能为以疾病为中心的临床研究和临床试验；通过组织临床研究项目、服务技术创新（药物等）方式来推进基地开放运行。</span></p>'
      + '<p style="margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">（三）分院和分中心：以两个基地为基础，发挥“大设施”服务与辐射功能，针对生命健康服务特点，设立分院和分中心。</span></p>'
      + '<p>&nbsp;</p>'
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
@media screen and (max-width:600px) {
  .b-banner-con{
    //padding: 22px 0;
    background: url(../../assets/img/banner_bg.png) no-repeat!important;
    background-size: cover!important;
    .b-header{
      margin-bottom: 0px;
    }
    height: 134px;
    width: 1440px;
  }
}

@media screen and (min-width:960px) {
  .b-banner-con{
    //padding: 22px 0;
    background: url(../../assets/img/banner_bg.png) no-repeat!important;
    background-size: cover!important;
    .b-header{
      margin-bottom: 0px;
    }
    height: 134px;
  }
}

.b-richtext {
  text-align:left;
  margin-top: -50px;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 20px;
  }
  line-height: 32px;
}

///////////////
.title {
  width: 250px;
  margin-top: 30px;
  margin-bottom: 0px;
  position: relative;
  padding: 10px 15px 11px;
  background: #0c5cc8;
  font-size: 22px;
  font-weight: 500;
  color:#ffffff;
  text-transform:uppercase;
}
.contentLeft {
  width: 250px;
  float: left;
  margin-right: 15px;
  top: 0;
  left: 0;
  background-color: #f2f7ff;
}

.contentRight {
  padding: 1.3rem 2rem;
  margin-left: 250px;
}

.leftNavigation {
  margin: 0rem 0;
}
.leftNavigation li {
  border-bottom: solid 1px #c6dbf5;
  border-right: solid 1px #c6dbf5;
  text-align: left;
}
.leftNavigation, .leftNavigation li ul {
  list-style: none;
  padding: 0;
}
.leftNavigation li a {
  font-size: 16px;
  display: block;
  padding: 10px 30px 10px 20px;
  color: #1f1f1f;
  /*border-bottom: solid 1px #1e76b8;*/
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
  -webkit-transition: color 0.2s ease;
  transition: color 0.2s ease;
  font-weight:400;border-left: #c6dbf5 solid 5px;
}
.leftNavigation li a, .leftNavigation li a .leftNavIcon {
  line-height: 160%;
}
.leftNavigation li a .leftNavIcon {
  position: absolute;
  top: 0;
  left: -1px;
  /*width: 3rem;*/
  padding: 6px 0;
  text-align: center;
  font-weight:100;color: #f2f7ff;font-size: 20px;
}
.leftNavigation li.active a .leftNavIcon {color: #7396c3;}
.leftNavigation li a .leftNavIcon1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 4rem;
  padding: 0.8rem 0;
  text-align: center;
}
.leftNavigation li a:hover {
  color: #142e8f; text-decoration:none; background:#d6e7fd;border-left: #7396c3 solid 5px;
}
.leftNavigation li a:hover .leftNavIcon {color: #7396c3;}
.leftNavigation li ul {
  /*display: none;*/
  margin: 0;border-top: solid 1px #c6dbf5;border-left: #c6dbf5 solid 5px;padding: 8px 0;
}
.leftNavigation li ul li { border-bottom: solid 0px #1e76b8;}
.leftNavigation li ul li a {
  border: 0px; font-size:13px; color:#383838; background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;padding: 5px 15px 5px 48px;border-left: 0;
}
.leftNavigation li ul li a:hover {
  background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;color:#142e8f;text-decoration:none;border: 0;
}
/*#

 li ul li:last-child a {
  border-bottom: none;
}*/
.leftNavigation li ul li.active a {
  color: #8bebff; text-decoration:none;
}
.leftNavigation li.active > a {
  color: #142e8f; text-decoration:none;border-left: #7396c3 solid 5px;
}
.leftNavigation li.active ul {
  display: block;border-top: solid 1px #1e76b8;
}
.leftNavigation > li.active {
  background-color: #d6e7fd;
}
.leftNavigation li ul li .level4 {border-top: solid 1px #1e76b8;}
.leftNavigation li ul li .level4 li a {
  border-bottom: solid 0px #D0E9F3; font-size:14px; color:#e2f5fa; padding-left:42px;background: transparent;border-left: #2473c0 solid 5px;
}
.leftNavigation li ul li .level4 li a:hover {color: #8bebff;}
.leftNavigation li ul li .level4 li {border-bottom: solid 1px #1e76b8;}
.leftNavigation li ul li .level4 li:last-child {border-bottom: solid 0px #D0E9F3;}

</style>



// WEBPACK FOOTER //
// src/pages/research_service/index.vue